import React from 'react';
import './AboutUs.css'; // reuse existing styles
import logo from '../assets/logo.png';
import MainMenu from '../components/MainMenu';
import heroImg from '../assets/about/hero-4.jpg';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const ClubActivities = () => {
  return (
    <div className="about-page">
      


  <div className="top-bar-wrapper">
  {/* Left: Ticker */}
  <div className="news-ticker">
    <div className="ticker-content">
      🎓 Admissions Open for 2025–2026 — Enroll Now at Universal Academy! 📢
    </div>
  </div>

  {/* Right: Location + Timing */}
   <div className="top-bar-info">
    <div className="top-item">
      <i className="fas fa-envelope"></i> universalacademy@gmail.com
    </div>
    <div className="top-item">
      <i className="fas fa-phone-alt"></i> 04368-221616
    </div>
    <div className="top-item">
      <i className="fas fa-map-marker-alt"></i> Neravy, Karaikal
    </div>
  
  </div>
</div>

	  
	<header className="logo-header">
  <div className="header-row">
    {/* Left: Logo */}
  <Link to="/" className="logo-area">
  <img src={logo} alt="Universal Academy Logo" />
</Link>
	
	{/* Title below logo+info */}
  <div className="school-title">
    <h1>UNIVERSAL ACADEMY</h1>
    <p>Affiliated to CBSE – Karaikal, Puducherry</p>
  </div>

    {/* Right: Contact Info */}
   
  </div>

  
</header>



<MainMenu />   

      {/* Hero */}
      <section className="about-hero">
	    <img src={heroImg} alt="Universal Academy Campus" />
        <div className="hero-text">
          <h1>CLUB ACTIVITIES</h1>
          <p>Where learning meets creativity, passion, and purpose.</p>
        </div>
      </section>

      {/* Introduction */}
      <section className="about-intro">
	  
        <h2>Club Activities at Our School</h2>
        <p>
          The joy and benefits of experiential learning can never be overlooked. The concept of CLUBS is seen as an opportunity for adaptation to life in the group, forming good life-long habits. Club activities supplement academics and give the students practical training which they require in day-to-day life. Our school has a wide range of clubs that promote learning by combining recreational and educational factors.
        </p>
      </section>

      {/* Clubs */}
     <section className="about-leaders club-zigzag" style={{ paddingTop: '0px' }}>
  
  {/* Literary Club */}
  <div className="leader-row">
    <div className="leader-image">
      <img src="/clubs/1.jpg" alt="Literary Club" />
    </div>
    <div className="leader-text">
      <h3>LITERARY CLUB</h3>
      <p>
        The Literary Club explores various dimensions of literature. It enhances writing skills and brings out students’ creativity. Students develop communication, oratorical, and dramatic abilities, preparing them for real-world tasks outside the classroom.
      </p>
    </div>
  </div>

  {/* Sports Club */}
  <div className="leader-row reverse">
    <div className="leader-image">
      <img src="/clubs/2.jpg" alt="Sports Club" />
    </div>
    <div className="leader-text">
      <h3>SPORTS CLUB</h3>
      <p>
        “A sound mind in a sound body.” Physical activity is essential for growing children. We offer indoor and outdoor sports programs that encourage strength, coordination, and a love for movement.
      </p>
    </div>
  </div>

  {/* Eco Club */}
  <div className="leader-row">
    <div className="leader-image">
      <img src="/clubs/3.jpg" alt="Eco Club" />
    </div>
    <div className="leader-text">
      <h3>ECO CLUB</h3>
      <p>
        Eco Club empowers students to participate in environmental projects. It promotes awareness, sustainability, and action beyond the syllabus. Students engage communities in promoting eco-friendly habits and develop a deep love for nature.
      </p>
    </div>
  </div>

  {/* Robotics Club */}
  <div className="leader-row reverse">
    <div className="leader-image">
      <img src="/clubs/4.jpg" alt="Robotics Club" />
    </div>
    <div className="leader-text">
      <h3>ROBOTICS CLUB</h3>
      <p>
        Focused on STEM education, the Robotics Club promotes problem-solving and collaboration. Students work in teams, face challenges, and innovate using real-world tech skills to build and code solutions.
      </p>
    </div>
  </div>

</section>


      {/* Footer */}
     <Footer /> 
    </div>
  );
};

export default ClubActivities;
